export default __webpack_public_path__ + "static/media/lds-logo_sk.c24c12ad7c1570cd.svg";